'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { useState, useEffect } from 'react'
import ImageGallery from 'react-image-gallery'
import { ChevronLeftIcon, ChevronRightIcon, MagnifyingGlassPlusIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid'
import { useResponsive } from 'ahooks'

import { Spotted } from '@cruz-com/lookup'
import { Button, Modal } from '@/components'

export function Photos(spotted: Spotted.Detail) {
  const [openModal, setOpenModal] = useState(false)

  // thumb position
  const responsive = useResponsive()
  const [thumbnailPosition, setThumbnailPosition] = useState<'right' | 'bottom'>('right')
  useEffect(() => {
    if (!responsive.xl) {
      if (thumbnailPosition !== 'bottom') {
        setThumbnailPosition('bottom')
      }
    } else {
      if (thumbnailPosition !== 'right') {
        setThumbnailPosition('right')
      }
    }
  }, [responsive])

  const { photo_list } = spotted
  const imgList = _.map(photo_list, (p) => {
    return {
      original: `${p.url}-xl.jpg`,
      thumbnail: `${p.url}-md.jpg`,
      originalAlt: `${spotted.title} - ${p.p_url} large`,
      thumbnailAlt: `${spotted.title} - ${p.p_url} medium`,
    }
  })

  if (_.isEmpty(spotted)) {
    return <></>
  }

  return (
    <>
      <Modal open={openModal} setOpen={setOpenModal} className='bg-zinc-200 p-4'>
        <div className='sticky top-[40px]'>
          <Button
            className='z-50 transaction rounded-full p-1 h-10 w-10 absolute -top-[30px] -right-[30px] shadow-md ring ring-zinc-200'
            onClick={() => setOpenModal(false)}
          >
            <XMarkIcon className='size-6 text-white' />
          </Button>
        </div>
        <ul role='list' className='flex flex-col justify-center gap-y-2'>
          {
            _.map(imgList, (x, i) => {
              return (
                <li key={i}>
                  <img src={x.original} />
                </li>
              )
            })
          }
        </ul>
      </Modal>
      <div className='mt-4 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-0 lg:p-4 shadow-inner'>
        <ImageGallery
          lazyLoad={true}
          infinite={true}
          items={imgList}
          thumbnailPosition={_.size(imgList) === 1 ? undefined : thumbnailPosition}
          showIndex={_.size(imgList) > 1}
          showThumbnails={_.size(imgList) > 1}
          showPlayButton={false}
          renderLeftNav={(onClick) => {
            return (
              <button type='button' onClick={onClick} className='img-gallery-btn left-0' aria-label='Previous Photo'>
                <ChevronLeftIcon className='h-16 w-16 text-white' />
              </button>
            )
          }}
          renderRightNav={(onClick) => {
            return (
              <button type='button' onClick={onClick} className={'img-gallery-btn right-0'} aria-label='Next Photo'>
                <ChevronRightIcon className='h-16 w-16 text-white' />
              </button>
            )
          }}
          renderFullscreenButton={() => {
            return (
              <button type='button' aria-label='Open Fullscreen' className={twMerge(
                'absolute transform right-0 bottom-0',
                'z-10 p-6 opacity-60 hover:opacity-90 hover:bg-zinc-900/30 transition'
              )} onClick={() => setOpenModal(true)}>
                <MagnifyingGlassPlusIcon className='h-16 w-16 text-white' />
              </button>
            )
          }}
        />
      </div>
    </>
  )
}